<app-header [header-data]="headerData"></app-header>
<div class="container-md px-5 px-md-0">
  <div class="creditor-portal">
    <div class="row ">
      <div class="col-12">
        <ul>
          <li>Your registration is completed.</li>
          <li>You may wish to print a copy of your proof of debt for future reference.</li>
          <li>Your proof of debt is not deemed as submitted until you receive a confirmation email from us confirming that your account is created.</li>
          <li>
            If you do not hear from us within 3 working days, please contact us. Please also check that emails from us have not been filtered to your junk or spam folder.
          </li>
        </ul>
        <div class="row">
          <div class="col-12 col-sm-6">
            <button type="button" class="secondary-button" (click)="redirectToHome()">HOME</button>
          </div>
          <div class="col-12 col-sm-6 text-right">
            <button type="button" class="primary-button bg-trasparent mb-0" (click)="printPage()">
              <img src="../../../../../../assets/images/creditor-portal/print.svg" alt="Print" class="pr-3" />
              PRINT
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
